import { ChangeEvent } from 'react'

import { ChipInput, ChipLabel, ChipWrapper } from './styled'

type FilterChipProps = {
  id: string
  name: string
  value: string
  label: string
  type?: 'radio' | 'checkbox'
  checked: boolean
  disabled?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const FilterChip = ({
  id,
  name,
  value,
  label,
  type = 'radio',
  checked,
  disabled = false,
  onChange,
}: FilterChipProps) => (
  <ChipWrapper>
    <ChipInput
      type={type}
      id={id}
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
    <ChipLabel htmlFor={id}>{label}</ChipLabel>
  </ChipWrapper>
)
